export default __webpack_public_path__ + "b8146ba8dc7ede78f538771bab5ab269.svg";